(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
if (!customElements.get('toffee-newsletter')) {
  customElements.define('toffee-newsletter', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.dialog = this.querySelector('dialog');
      this.teaser = this.querySelector('.toffee-newsletter__teaser');
      this.key = this.dataset.storageKey;
      this.editor = this.dataset.editor === 'true';
      this.querySelector('[data-newsletter-open]').addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        this.open(true);
      }, options);
      this.querySelector('[data-newsletter-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => {
        if (!this.editor && !this.disconnecting) this.save('sessionStorage', ':open', 'false');
        this.teaser.hidden = this.read('localStorage', ':filled') === 'true';
        if (this.dialog.contains(document.activeElement) && this.lastFocus?.isConnected) this.lastFocus.focus({ preventScroll: true });
      }, options);
      const isReturn = new URL(location.href).searchParams.get('toffee_newsletter') === '1';
      if (isReturn && this.querySelector('[data-newsletter-success]')) this.save('localStorage', ':filled', 'true');
      this.teaser.hidden = this.read('localStorage', ':filled') === 'true';
      if (isReturn && this.querySelector('[data-newsletter-success], [data-newsletter-errors]')) {
        this.open(true);
      } else if (!this.editor && this.read('sessionStorage', ':open') === 'true' && this.read('localStorage', ':filled') !== 'true') {
        this.open();
      } else if (!this.editor && this.read('localStorage', ':filled') !== 'true' && !(this.dataset.onlyOnce === 'true' && this.read('sessionStorage', ':seen') === 'true')) {
        this.schedule();
      }
      document.addEventListener('shopify:section:select', event => {
        if (event.target.contains(this)) this.open(true);
      }, options);
      document.addEventListener('shopify:section:deselect', event => {
        if (event.target.contains(this) && this.dialog.open) this.dialog.close();
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden && this.autoPending) this.schedule(1000);
      }, options);
    }
    read(storage, suffix) {
      try { return window[storage].getItem(this.key + suffix); } catch { return null; }
    }
    save(storage, suffix, value) {
      try { window[storage].setItem(this.key + suffix, value); } catch {}
    }
    schedule(delay = Number(this.dataset.delay) * 1000) {
      clearTimeout(this.timer);
      this.autoPending = true;
      this.timer = setTimeout(() => {
        if (document.hidden) return;
        if (document.querySelector('dialog[open], cart-drawer[open], search-drawer[open], .shopify-pc__banner__dialog')) return this.schedule(2000);
        this.open();
      }, delay);
    }
    open(focus = false) {
      clearTimeout(this.timer);
      this.autoPending = false;
      if (this.dialog.open) return;
      this.lastFocus = document.activeElement;
      this.dialog.show();
      if (!this.editor) {
        this.save('sessionStorage', ':seen', 'true');
        this.save('sessionStorage', ':open', 'true');
      }
      this.teaser.hidden = true;
      if (focus) this.querySelector('[data-newsletter-success], [data-newsletter-errors], .toffee-newsletter__title')?.focus({ preventScroll: true });
      else if (this.lastFocus?.isConnected) this.lastFocus.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      this.disconnecting = true;
      clearTimeout(this.timer);
      if (this.dialog?.open) this.dialog.close();
      this.abort?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toffee-community-videos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('toffee-community-videos')) {
  customElements.define('toffee-community-videos', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.toffee-community__track');
      if (!this.track) {
        if (!this.initFrame) this.initFrame = requestAnimationFrame(() => { if (this.isConnected) this.connectedCallback(); });
        return;
      }
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.originalCards = Array.from(this.querySelectorAll('.toffee-community__card:not([data-community-clone])'));
      this.total = this.originalCards.length;
      this.originalCards.forEach((card, index) => { card.dataset.communityIndex = index; });
      if (this.total > 1) {
        const before = document.createDocumentFragment(), after = document.createDocumentFragment();
        this.originalCards.forEach(card => {
          [before, after].forEach(fragment => {
            const clone = card.cloneNode(true);
            clone.setAttribute('data-community-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            clone.removeAttribute('data-shopify-editor-block');
            clone.querySelectorAll('button, a').forEach(control => { control.tabIndex = -1; });
            fragment.append(clone);
          });
        });
        this.track.prepend(before);
        this.track.append(after);
      }
      this.cards = Array.from(this.querySelectorAll('.toffee-community__card'));
      this.videos = this.cards.map(card => card.querySelector('video'));
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.visible = false;
      this.hovered = false;
      this.held = false;
      this.manualUntil = 0;
      this.index = Math.min(2, this.total - 1);
      this.activeCard = null;
      this.soundEnabled = false;
      this.soundVolume = 1;
      this.hasActivated = false;
      this.lastStamp = 0;
      this.viewer = this.querySelector('.toffee-community__viewer');
      this.viewerSlot = this.viewer.querySelector('.toffee-community__viewer-slot');
      this.viewer.addEventListener('click', event => {
        if (event.target.closest('[data-community-close]')) this.close();
        const step = event.target.closest('[data-community-viewer-step]');
        if (step) this.open(this.originalCards[(this.viewerIndex + Number(step.dataset.communityViewerStep) + this.total) % this.total]);
        const video = this.viewerVideo;
        if (!video) return;
        if (event.target.closest('[data-community-pause]')) {
          if (video.paused) this.playViewer();
          else video.pause();
        }
        if (event.target.closest('[data-community-sound]')) {
          this.soundEnabled = video.muted;
          video.muted = !this.soundEnabled;
          video.volume = this.soundVolume || 1;
          if (video.paused) this.playViewer();
          this.syncViewer();
        }
        if (event.target.closest('[data-community-fullscreen]')) {
          if (video.requestFullscreen) video.requestFullscreen().catch(() => {});
          else video.webkitEnterFullscreen?.();
        }
      }, { signal });
      this.viewer.addEventListener('close', () => this.close(false), { signal });
      this.videos.forEach(video => {
        video.addEventListener('loadeddata', () => video.setAttribute('data-ready', ''), { signal });
        video.addEventListener('playing', () => video.setAttribute('data-ready', ''), { signal });
      });
      this.track.addEventListener('volumechange', e => {
        const video = e.target;
        if (!(video instanceof HTMLVideoElement) || !video.controls) return;
        const r = video.closest('.toffee-community__card').getBoundingClientRect(), t = this.track.getBoundingClientRect();
        if (video.closest('.toffee-community__card') !== this.activeCard && Math.abs(r.left + r.width / 2 - t.left - t.width / 2) > 2) return;
        this.soundEnabled = !video.muted && video.volume > 0;
        this.soundVolume = video.volume;
      }, { signal, capture: true });
      this.track.addEventListener('scroll', () => {
        this.lastScroll = performance.now();
        if (this.autoscrolling) return;
        this.position = this.track.scrollLeft;
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.update());
      }, { signal });
      this.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse' && matchMedia('(min-width: 700px) and (hover: hover)').matches) this.hovered = true; }, { signal });
      this.addEventListener('pointerleave', () => { this.hovered = false; this.lastStamp = 0; }, { signal });
      this.track.addEventListener('pointerdown', () => { this.held = true; this.autoscrolling = false; this.manualUntil = Date.now() + 4000; }, { signal });
      this.track.addEventListener('wheel', () => { this.autoscrolling = false; this.manualUntil = Date.now() + 4000; }, { signal, passive: true });
      document.addEventListener('pointerup', () => { this.held = false; }, { signal });
      document.addEventListener('pointercancel', () => { this.held = false; }, { signal });
      this.track.addEventListener('keydown', e => {
        if (e.code === 'Space' && e.target === this.track) {
          e.preventDefault();
          this.paused = !this.paused;
          this.lastStamp = 0;
          this.update();
        }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault();
          this.autoscrolling = false; this.manualUntil = Date.now() + 4000;
          this.go(this.index + (e.key === 'ArrowRight' ? 1 : -1));
        }
      }, { signal });
      this.addEventListener('click', e => {
        const sound = e.target.closest('[data-community-preview-sound]');
        if (sound) {
          if (this.activeCard) this.close(false);
          this.soundEnabled = !this.soundEnabled;
          this.hasActivated = true;
          this.manualUntil = Date.now() + 4000;
          this.go(Number(sound.closest('.toffee-community__card').dataset.communityIndex), false);
          this.update();
          return;
        }
        const open = e.target.closest('[data-community-open]');
        if (open) this.open(open.closest('.toffee-community__card'));
        const step = e.target.closest('[data-community-step]');
        if (step) {
          this.autoscrolling = false; this.manualUntil = Date.now() + 4000;
          this.go(this.index + Number(step.dataset.communityStep));
        }

      }, { signal });
      document.addEventListener('keydown', e => { if (e.key === 'Escape' && this.activeCard) this.close(); }, { signal });
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.viewerVideo?.pause(); this.update(); }, { signal });
      document.addEventListener('toffee:community-open', e => { if (e.detail !== this && this.activeCard) this.close(false); }, { signal });
      this.motion.addEventListener('change', () => { this.paused = this.motion.matches; this.update(); }, { signal });
      document.addEventListener('shopify:block:select', e => {
        const card = e.target.closest('.toffee-community__card');
        if (card && this.cards.includes(card)) {
          this.paused = true;
          this.go(Number(card.dataset.communityIndex), false);
        }
      }, { signal });
      this.visibility = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.lastStamp = 0;
        this.update();
      }, { threshold: .1 });
      this.visibility.observe(this.track);
      this.resize = new ResizeObserver(() => { this.measure(); this.go(this.index, false); });
      this.resize.observe(this.track);
      this.measure();
      this.go(this.index, false);
      const animate = stamp => {
        if (!this.controller) return;
        this.lastStamp = stamp;
        const stop = this.paused || this.motion.matches || !this.visible || this.held || document.hidden || this.activeCard || this.track.matches(':focus-visible') || Date.now() < this.manualUntil;
        const move = !stop && this.dataset.rotate === 'true' && this.total > 1;
        this.autoscrolling = false;
        this.position = this.track.scrollLeft;
        if (!this.held && !this.activeCard && stamp - (this.lastScroll || 0) > 300) {
          this.normalize();
          const nearest = this.cards.filter(card => Number(card.dataset.communityIndex) === this.index).sort((a, b) => Math.abs(a.getBoundingClientRect().left + a.offsetWidth / 2 - this.track.getBoundingClientRect().left - this.track.clientWidth / 2) - Math.abs(b.getBoundingClientRect().left + b.offsetWidth / 2 - this.track.getBoundingClientRect().left - this.track.clientWidth / 2))[0];
          const target = nearest.offsetLeft - this.track.offsetLeft - (this.track.clientWidth - nearest.offsetWidth) / 2;
          if (Math.abs(this.track.scrollLeft - target) > 1) this.go(this.index);
        }
        if (move && this.previewVideo?.ended && this.advanceFrom !== this.previewVideo && stamp - (this.lastScroll || 0) > 300) {
          this.advanceFrom = this.previewVideo;
          this.go(this.index + 1);
        }
        if (stamp - (this.lastUpdate || 0) > 100) { this.update(); this.lastUpdate = stamp; }
        this.animation = requestAnimationFrame(animate);
      };
      this.animation = requestAnimationFrame(animate);
    }
    get speed() {
      const ratio = matchMedia('(max-width: 699px)').matches ? .6 : 1;
      return Math.max(6, Number(this.dataset.speed || 18)) * ratio;
    }
    measure() {
      const first = this.originalCards[0];
      this.base = first.offsetLeft - this.track.offsetLeft - (this.track.clientWidth - first.offsetWidth) / 2;
      this.cycle = this.total > 1 ? this.cards[this.total * 2].offsetLeft - first.offsetLeft : 0;
    }
    normalize() {
      if (!this.cycle) return;
      const previous = this.position;
      while (this.position < this.base) this.position += this.cycle;
      while (this.position >= this.base + this.cycle) this.position -= this.cycle;
      if (Math.abs(this.position - previous) > 1) {
        this.videos.forEach(video => {
          const card = video.closest('.toffee-community__card');
          const source = this.videos.find(other => other !== video && other.readyState >= 2 && other.closest('.toffee-community__card').dataset.communityIndex === card.dataset.communityIndex);
          if (source && video.readyState >= 2 && Math.abs(video.currentTime - source.currentTime) > .25) {
            try { video.currentTime = source.currentTime; } catch (_) {}
          }
        });
        this.track.scrollLeft = this.position;
        this.update();
      }
    }
    go(index, smooth = true) {
      this.index = (index + this.total) % this.total;
      const targets = this.cards.filter(card => Number(card.dataset.communityIndex) === this.index);
      const position = card => card.offsetLeft - this.track.offsetLeft - (this.track.clientWidth - card.offsetWidth) / 2;
      const card = smooth ? targets.sort((a, b) => Math.abs(position(a) - this.track.scrollLeft) - Math.abs(position(b) - this.track.scrollLeft))[0] : this.originalCards[this.index];
      this.autoscrolling = false;
      this.position = position(card);
      this.track.scrollTo({ left: this.position, behavior: smooth && !this.motion.matches ? 'smooth' : 'instant' });
      this.update();
    }
    update() {
      if (!this.isConnected) return;
      const rect = this.track.getBoundingClientRect();
      const center = rect.left + rect.width / 2;
      let nearest = this.index, distance = Infinity;
      this.cards.forEach((card, i) => {
        const r = card.getBoundingClientRect();
        const d = Math.abs(r.left + r.width / 2 - center);
        if (d < distance) { distance = d; nearest = Number(card.dataset.communityIndex); }
      });
      this.index = nearest;
      this.cards.forEach((card, i) => {
        const raw = Math.abs(Number(card.dataset.communityIndex) - nearest);
        const d = Math.min(raw, this.total - raw);
        card.dataset.distance = d === 0 ? 'center' : d === 1 ? 'near' : d === 2 ? 'far' : 'hidden';
        card.toggleAttribute('data-sound', this.soundEnabled);
        const soundButton = card.querySelector('[data-community-preview-sound]');
        soundButton.setAttribute('aria-label', this.soundEnabled ? soundButton.dataset.muteLabel : soundButton.dataset.unmuteLabel);
        const r = card.getBoundingClientRect();
        const video = this.videos[i];
        if (video === this.viewerVideo) return;
        const centered = card.dataset.distance === 'center' && r.right > rect.left && r.left < rect.right;
        video.loop = this.dataset.rotate !== 'true' || this.total < 2;
        if (centered) {
          if (this.previewIndex !== nearest) {
            try { video.currentTime = 0; } catch (_) {}
            this.advanceFrom = null;
          }
          this.previewIndex = nearest;
          this.previewVideo = video;
        }
        video.controls = false;
        card.removeAttribute('data-controls');
        if (this.visible && d <= 2 && !video.getAttribute('src') && video.dataset.src) {
          video.preload = 'metadata';
          video.src = video.dataset.src;
        }
        const play = this.visible && !document.hidden && !this.paused && !this.motion.matches && !this.activeCard && centered;
        if (play) {
          if (!video.getAttribute('src') && video.dataset.src) video.src = video.dataset.src;
          if (video.paused && !video.ended && video.getAttribute('src')) {
            video.muted = !this.soundEnabled;
            video.volume = this.soundVolume;
            video.play().catch(() => {});
          }
        } else {
          video.pause();
          if (!centered) video.muted = true;
        }
        if (play) video.muted = !this.soundEnabled;
      });
    }
    open(card) {
      document.dispatchEvent(new CustomEvent('toffee:community-open', { detail: this }));
      if (card === this.activeCard) { this.playViewer(); return; }
      this.restoreViewerVideo();
      const original = card.querySelector('video');
      this.lastOpener = card.querySelector('[data-community-open]');
      this.viewerIndex = Number(card.dataset.communityIndex);
      this.activeCard = card;
      const video = original;
      this.viewerHome = video.parentElement;
      video.className = 'toffee-community__viewer-video';
      video.setAttribute('playsinline', '');
      if (!video.getAttribute('src')) video.src = video.dataset.src || video.dataset.fullSrc;
      video.preload = 'auto';
      video.controls = false;
      video.volume = this.soundVolume || 1;
      video.muted = this.hasActivated && !this.soundEnabled;
      video.loop = false;
      this.hasActivated = true;
      this.soundEnabled = !video.muted;
      this.viewerVideo = video;
      this.viewerSlot.replaceChildren(video);
      this.viewer.querySelector('[role="status"]').hidden = true;
      if (this.viewer.parentElement !== document.body) document.body.append(this.viewer);
      if (!this.viewer.open) this.viewer.show();
      this.boundViewerVideos ||= new WeakSet();
      if (!this.boundViewerVideos.has(video)) {
        this.boundViewerVideos.add(video);
        ['play', 'pause', 'ended', 'volumechange'].forEach(name => video.addEventListener(name, () => this.syncViewer(), { signal: this.controller.signal }));
        video.addEventListener('volumechange', () => {
          if (video !== this.viewerVideo) return;
          this.soundEnabled = !video.muted && video.volume > 0;
          this.soundVolume = video.volume;
        }, { signal: this.controller.signal });
        video.addEventListener('error', () => { if (video === this.viewerVideo) this.viewer.querySelector('[role="status"]').hidden = false; }, { signal: this.controller.signal });
      }
      this.update();
      this.syncViewer();
      this.playViewer();
    }
    playViewer() {
      const video = this.viewerVideo;
      if (!video) return;
      this.viewer.querySelector('[role="status"]').hidden = true;
      video.play().catch(error => {
        if (video === this.viewerVideo && error.name !== 'AbortError') {
          this.viewer.querySelector('[role="status"]').hidden = false;
          this.syncViewer();
        }
      });
    }
    syncViewer() {
      const video = this.viewerVideo;
      if (!video) return;
      this.viewer.toggleAttribute('data-paused', video.paused);
      this.viewer.toggleAttribute('data-muted', video.muted);
      const pause = this.viewer.querySelector('[data-community-pause]');
      pause.setAttribute('aria-label', video.paused ? pause.dataset.playLabel : pause.dataset.pauseLabel);
      const sound = this.viewer.querySelector('[data-community-sound]');
      sound.setAttribute('aria-label', video.muted ? sound.dataset.unmuteLabel : sound.dataset.muteLabel);
    }
    close(restore = true) {
      if (!this.activeCard) return;
      this.activeCard = null;
      this.restoreViewerVideo();
      this.viewerSlot?.replaceChildren();
      if (this.viewer?.open) this.viewer.close();
      this.manualUntil = 0;
      this.lastStamp = 0;
      this.update();
      if (restore && this.lastOpener?.isConnected) this.lastOpener.focus({ preventScroll: true });
    }
    restoreViewerVideo() {
      const video = this.viewerVideo;
      if (!video) return;
      this.viewerVideo = null;
      video.pause();
      video.muted = true;
      video.loop = this.dataset.rotate !== 'true' || this.total < 2;
      video.controls = false;
      video.className = 'toffee-community__video';
      this.viewerHome?.insertBefore(video, this.viewerHome.querySelector('[data-community-open]'));
      this.viewerHome = null;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      cancelAnimationFrame(this.animation);
      cancelAnimationFrame(this.scrollFrame);
      cancelAnimationFrame(this.initFrame);
      this.initFrame = null;
      this.visibility?.disconnect();
      this.resize?.disconnect();
      this.videos?.forEach(video => video.pause());
      this.querySelectorAll('[data-community-clone]').forEach(clone => clone.remove());
      this.lastStamp = 0;
      this.autoscrolling = false;
      this.close(false);
      this.viewer?.remove();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toffee-creator-stories"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('toffee-creator-stories')) {
  customElements.define('toffee-creator-stories', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.viewer = this.querySelector('dialog');
      this.video = this.querySelector('video');
      this.addEventListener('click', event => {
        const portrait = event.target.closest('[data-creator-video]');
        if (portrait) {
          document.dispatchEvent(new CustomEvent('toffee:creator-story-open', { detail: this }));
          this.video.pause();
          this.video.src = portrait.dataset.creatorVideo;
          this.video.setAttribute('aria-label', portrait.dataset.creatorName);
          this.querySelector('[data-creator-title]').textContent = portrait.dataset.creatorName;
          this.opener = portrait;
          if (!this.viewer.open) this.viewer.show();
          this.video.play().catch(() => {});
        }
        if (event.target.closest('[data-creator-close]')) this.close();
      }, { signal });
      this.viewer.addEventListener('cancel', () => this.close(), { signal });
      this.viewer.addEventListener('close', () => this.video.pause(), { signal });
      document.addEventListener('keydown', event => { if (event.key === 'Escape' && this.viewer.open) this.close(); }, { signal });
      document.addEventListener('toffee:creator-story-open', event => { if (event.detail !== this && this.viewer.open) this.close(false); }, { signal });
    }
    close(restore = true) {
      this.video.pause();
      this.video.removeAttribute('src');
      this.video.load();
      this.viewer.close();
      if (restore) this.opener?.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      this.video?.pause();
      this.viewer?.close();
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
